import { K1Information } from '@e3dc-react/icons'
import { Box, Typography } from '@mui/material'
import React from 'react'

interface InformationBannerProps {
  message: string
  suffix?: React.ReactNode
}

/** Banner to display important information. */
export const InformationBanner: React.FC<InformationBannerProps> = ({ message, suffix }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: { xs: 'column', md: 'row' },
        gap: 2,
        bgcolor: 'grey.grey07',
        border: '1px solid grey.grey06',
        borderRadius: 1,
        px: 2,
        py: 4,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          px: 2,
        }}
      >
        <K1Information fontSize="medium" />
        <Typography variant="body2">{message}</Typography>
      </Box>

      {suffix}
    </Box>
  )
}
